import React, {useEffect, useState} from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import * as Auth from "../service/auth.service";
import {pathRoutes} from "../props/util.props";
import {useQuery} from "@tanstack/react-query";
import {getCustomMenu} from "../service/apps.service";
import UILeftMenuMainPage from "../components/shared/leftMenu/UILeftMenuMainPage";
import {CenterMenu} from "../components/Menu/CenterMenu/CenterMenu";

const PrivateRoute = () => {
    // const [auth, setAuth] = useState(true);

    const {
        isError,
        isLoading,
        data: auth,
    } = useQuery(["auth"], Auth.checkAuth, {
        // retry: 10,
        // onSuccess: (data) => {
        //     sett_custom(data.customlink);
        //     if (location.pathname === pathRoutes.Home || location.pathname === "/") {
        //         let customMenuObj = data.customlink;
        //         const customHome = customMenuObj.find(
        //             (menu: any) => menu?.key === "home" && menu?.type === "custom"
        //         );
        //         if (customHome) {
        //             props.navigate({
        //                 pathname: pathRoutes.CustomMenu + "/" + customHome?.key,
        //                 state: {res: customHome},
        //             });
        //         }
        //     }
        // }
    })

    // useEffect(() => {
    //     checkAuth();
    // }, []);

    // const checkAuth = async () => {
    //     let auth: any = await Auth.checkAuth();
    //     console.log("auth", auth);
    //     setAuth(auth);
    // };

    return ((isLoading && !isError) || auth ? <CenterMenu><Outlet /></CenterMenu> : <Navigate to={pathRoutes.Login}/>);
};

export default PrivateRoute;
